import { HTMLAttributes, PropsWithChildren } from 'react'

import { FireStyledSection } from './FireSection.styles'
import { FireSectionProps } from './FireSection.types'

export const FireSection: React.FC<
  PropsWithChildren<FireSectionProps & HTMLAttributes<HTMLDivElement>>
> = ({ children, bleed, background, verticalSpacing, ...props }) => {
  if (!children) return null

  return (
    <FireStyledSection
      {...props}
      $bleed={bleed}
      $background={background}
      $verticalSpacing={verticalSpacing}
    >
      {children}
    </FireStyledSection>
  )
}
